<!--
 * @Description: 我的值班 值班日志记录
 * @Author: PF
 * @Date: 2023-09-01 14:37:20
 * @LastEditors: PF
 * @LastEditTime: 2024-10-11 09:19:12
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="wp65 hp65" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">值班日志记录</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
        <!-- 冻结列-Left BEGIN -->
        <el-table-column label="序号" type="index" fixed align="center" width="80" />
        <el-table-column label="值班人姓名" prop="zbryxm" fixed align="center" show-overflow-tooltip />
        <!-- 冻结列-Left END -->
        <el-table-column label="值班类别" prop="zblbmc" align="center" show-overflow-tooltip />
        <el-table-column label="值班内容名称" prop="zbnrmc" align="center" show-overflow-tooltip />
        <el-table-column label="值班日期" prop="zbrq" align="center" show-overflow-tooltip />
        <el-table-column label="值班时间" align="center" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.zbkssj }}
            <span v-if="scope.row.zbkssj && scope.row.zbjssj">至</span>
            {{ scope.row.zbjssj }}
          </template>
        </el-table-column>
        <el-table-column label="手机" prop="yddh" align="center" show-overflow-tooltip />
        <!-- 冻结列-Right BEGIN -->
        <el-table-column label="操作" width="80" fixed="right" align="center">
          <template #default="scope">
            <el-button link type="success" @click="openRiZhiDetail=true; row=scope.row">详情</el-button>
          </template>
        </el-table-column>
        <!-- 冻结列-Right END -->
      </el-table>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </div>
      </template>
    </el-dialog>
  </div>
  <detail v-if="openRiZhiDetail" v-model:openDetail="openRiZhiDetail" :row="row" />
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, loadList } from '@/api/common'
import pagination from '@/components/pagination.vue'
import detail from '@/pages/bangong/zhibanguanli/zhibanrizhi/detail.vue'
const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail', 'ReturnData'])

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'zbrq', order: 'descending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/bangong/zhibanrenyuanjilu/zhibanrizhibyzhibanneironglist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      dataGrid.value.parms.zbnrmc = props.row.zbnrmc
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
const row = ref()
const openRiZhiDetail = ref(false)
</script>
